const RBGTheme = {
  accentColor: '#81d612',
  primaryColor: '#006600',
  primaryColorLight: '#038403',
  secondaryColor: '#ffe433',
  secondaryColorLight: '#fff382',
  lightColor: '#fffdfa',
  lightColorAlt: '#fdf3e5',
  bodyColor: '#607568',
  black: '#3d4852',
  fontHeading: "'Roboto Slab', 'Times New Roman', serif",
  fontBody: "'Cabin Condensed', Georgia, serif",
}

export default RBGTheme
